import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Agenda, api, fmtDay, Task } from '../api';
import { ErrorBox, useAsync } from '../components/ui';
import { TaskForm, TaskRow, useMembers } from '../components/TaskList';
import { useSession } from '../session';

/** Napi teendőlista (szabály alapján; AI nélkül is teljes): lejárt, mai, következő 7 nap, határidő nélküli + elakadt dealek. */
export function TasksPage() {
  const s = useSession();
  const members = useMembers();
  const [user, setUser] = useState(s.me!.user.id);
  const [ag, setAg] = useState<Agenda | null>(null);
  const [adding, setAdding] = useState(false);
  const [done, setDone] = useState<Task[] | null>(null);
  const a = useAsync();
  const load = () => a.run(async () => {
    setAg(await api<Agenda>(`/tasks/agenda?user_id=${user}`));
    if (done) setDone((await api<{ items: Task[] }>(`/tasks?assignee=${user}&status=done&limit=30`)).items);
  });
  useEffect(() => { load(); }, [user]);
  const showDone = async () => a.run(async () => setDone((await api<{ items: Task[] }>(`/tasks?assignee=${user}&status=done&limit=30`)).items));

  const group = (title: string, items: Task[] | undefined, cls = '') => items && items.length > 0 && (
    <section className={`card ${cls}`}>
      <h3>{title} <span className="muted">({items.length})</span></h3>
      <ul className="plain tasks">{items.map((t) => <TaskRow key={t.id} t={t} onChange={load} />)}</ul>
    </section>
  );
  const empty = ag && !ag.overdue.length && !ag.today.length && !ag.upcoming.length && !ag.undated.length;
  return (
    <div>
      <div className="page-head">
        <h2>Feladatok</h2>
        {ag && <span className="muted">{fmtDay(ag.date)}</span>}
        <div className="spacer" />
        {members.length > 1 && (
          <select aria-label="Kinek a listája" value={user} onChange={(e) => setUser(e.target.value)} style={{ width: 'auto' }}>
            {members.map((m) => <option key={m.id} value={m.id}>{m.id === s.me!.user.id ? 'Saját' : m.name}</option>)}
          </select>
        )}
        {!adding && <button onClick={() => setAdding(true)}>Új feladat</button>}
      </div>
      {adding && <section className="card"><h3>Új feladat</h3><TaskForm onDone={() => { setAdding(false); load(); }} onCancel={() => setAdding(false)} /></section>}
      <ErrorBox error={a.error} />
      <div className="cols">
        <div>
          {group('Lejárt', ag?.overdue, 'overdue-card')}
          {group('Ma', ag?.today)}
          {group('Következő 7 nap', ag?.upcoming)}
          {group('Határidő nélkül', ag?.undated)}
          {empty && <section className="card"><p className="muted">Nincs nyitott feladat a következő hétre.</p></section>}
          {done ? group('Legutóbb lezárt', done) : <button className="secondary" onClick={showDone}>Lezárt feladatok mutatása</button>}
        </div>
        <div>
          <section className="card">
            <h3>Elakadt dealek</h3>
            <ul className="plain">
              {ag?.stale_deals.map((d) => (
                <li key={d.id}><Link to={`/ertekesites/${d.id}`}>{d.title}</Link> <span className="muted">· {d.stage_name} · {d.days_in_stage} napja</span></li>
              ))}
              {ag?.stale_deals.length === 0 && <li className="muted">Nincs elakadt deal.</li>}
            </ul>
          </section>
        </div>
      </div>
    </div>
  );
}
